<script>
    import { onMount } from "svelte";
    import { fade } from 'svelte/transition';
    
    import {user} from '../store/authStore';
    import  {page} from '../store/nav';

    import { getAuth, signOut, signInWithPopup, GoogleAuthProvider, TwitterAuthProvider, OAuthProvider, FacebookAuthProvider, createUserWithEmailAndPassword} from "firebase/auth";

    const provider_list = {
        google: GoogleAuthProvider,
        fb:  FacebookAuthProvider,
        twitter: TwitterAuthProvider,
        microsoft:  OAuthProvider,
        yahoo:  OAuthProvider
    };

    let el = {};

    onMount(async () => {
        el.logo = document.querySelector('#logo');
        el.welcome = document.querySelector('#welcome');
        el.providers= document.querySelector('#providers');
    });

    const sso = {
        google: async () => {
            await sso.login(getAuth(), `google`, new GoogleAuthProvider());
        },
        fb: async () => {
            await sso.login(getAuth(), `fb`, new FacebookAuthProvider());
        },
        twitter: async () => {
            await sso.login(getAuth(), `twitter`, new TwitterAuthProvider());
        },
        yahoo: async () => {
            await sso.login(getAuth(), `yahoo`, new OAuthProvider('yahoo.com'));
        },
        microsoft: async () => {
            await sso.login(getAuth(), `microsoft`, new OAuthProvider('microsoft.com'));
        },
        login : async (auth, idp, instance) => {
            const provider = provider_list[idp];
            signInWithPopup(auth, instance)
            .then((result) => {
                // This gives you a Google Access Token. You can use it to access the Google API.
                const credential = provider.credentialFromResult(result);
                if(credential){
                    const token = credential.accessToken;
                    // The signed-in user info.
                    const user = result.user;
                    
                    el.providers.classList.add('hidden');
                    el.welcome.classList.add('hidden');
                    el.logo.classList.add('h-1/2');
                    el.logo.classList.add('translate-y-1/2');

                    setTimeout(() => {
                        page.route("/menu");
                    }, 1000);
                   
                }
            }).catch((error) => {
                // Handle Errors here.
                const errorCode = error.code;
                const errorMessage = error.message;
                // The email of the user's account used.
                const email = error.email;
                // The AuthCredential type that was used.
                const credential = provider.credentialFromError(error);
                // ...
                console.log(error);
            });
        }
    }

    const logNoAccount = () => {
        const localProfile = localStorage.getItem("pc_userProfile");
        const profile = localProfile ? JSON.parse(localProfile) : {
            isLoggedIn: true,
            displayName: "",
            photoURL: "",
            email: "",
            phoneNumber: "",
            isAnonymous: true
        };

        user.set(profile);
        localStorage.setItem("localProfile", JSON.stringify(profile));

        el.providers.classList.add('hidden');
        el.welcome.classList.add('hidden');
        el.logo.classList.add('h-1/2');
        el.logo.classList.add('translate-y-1/2');

        setTimeout(() => {
            page.route("/menu");
        }, 1000);

    };

    async function logout(){
        const auth = getAuth();
        signOut(auth).then(() => {
            page.route("/login");
        // Sign-out successful.
        }).catch((error) => {
        // An error happened.
        });
    }
</script>

<section out:fade="{{delay:250, duration: 250 }}" id="signin" class="z-0 fixed top-0 left-0 h-screen w-screen font-primaryBold text-secondary bg-gradient-to-br from-bright_accent to-dark_accent" >
    <section id="home-main-grid" class=" h-full">
        <ul class="bg-bubbles">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
        </ul>
        <section in:fade="{{delay: 350, duration: 100 }}" class="flex flex-col space-y-5 pt-5 px-7 h-full justify-between">
            <section id="logo"  class="flex shrink-0 duration-500 z-20">
                <img src="/img/icon/prep_chef_white.png" class="w-44 mx-auto place-self-center my-12" alt="">
            </section>
            <section id="welcome" class="shrink-0 mx-auto z-20">
                <p>Hey there! First let's get you in</p>
            </section>
            <section id="providers" class="flex flex-col grow space-y-8 mx-auto py-12 duration-300 z-20 overflow-y-auto no-scrollbar">
                <section class="flex flex-col  space-y-8 mx-auto">
                    <div id="google-provider" class="bg-white/30 border border-secondary/60 w-14 h-14 shrink-0 rounded-full m-auto">
                        <img src="/img/icon/idps/google.png" class="m-auto mt-3.5 h-7"  on:click={sso.google}  alt="Google">
                    </div>
                    <div id="fb-provider" class="bg-white/30 border border-secondary/60 w-14 h-14 shrink-0 rounded-full m-auto">
                        <img src="/img/icon/idps/fb.png"  class="m-auto mt-3 h-8" on:click={sso.fb} alt="Fb">
                    </div>
                    <div id="twitter-provider" class="bg-white/30 border border-secondary/60 w-14 h-14 shrink-0 rounded-full m-auto">
                        <img src="/img/icon/idps/twitter.png" class="m-auto mt-3.5 h-7" on:click={sso.twitter} alt="Twitter">
                    </div>
                    <div id="yahoo-provider" class="bg-white/30 border border-secondary/60 w-14 h-14 shrink-0 rounded-full m-auto">
                        <img src="/img/icon/idps/yahoo.png" class="m-auto mt-3.5 h-7" on:click={sso.yahoo} alt="Yahoo">
                    </div>
                    <div id="msft-provider" class="bg-white/30 border border-secondary/60 w-14 h-14 shrink-0 rounded-full m-auto">
                        <img src="/img/icon/idps/microsoft.png"  class="m-auto mt-3.5 h-7" on:click={sso.microsoft} alt="Microsoft">
                    </div>
                    <div id="no-account" class="bg-white/10 border place-self-center border-secondary/30 px-2 h-9 shrink-0 m-auto text-center flex flex-col">
                        <span on:click="{logNoAccount}">Public access - No account needed</span>
                    </div>
                </section>
            </section>
        </section>
    </section>
    
    <!--
        <div id="home-app-icon" class="w-7 h-7 rounded-full" >
        <img src="/img/icon/main.png" alt="ico"/>
    </div>
    <section id="app-greetings" class="">
        <div class="text-sm">Let's start</div>
        <div class="mt-2 font-secondary text-3xl">Meal planner</div>
    </section>
    
    <div class=" text-xs">Chose your favorite option to sign in</div>
    <section id="email-provider" class="">
        <section class="form-input-text relative h-16 text-secondary">
            <span class="absolute inset-y-0 left-0 h-16 z-10 flex items-center pl-6">
                <button type="submit" class="p-1 focus:outline-none focus:shadow-outline">
                    <svg viewBox="0 0 20 20" class="w-5 h-5 fill-secondary">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.833313 5C0.833313 3.61929 1.9526 2.5 3.33331 2.5H16.6666C18.0474 2.5 19.1666 3.61929 19.1666 5V15C19.1666 16.3807 18.0474 17.5 16.6666 17.5H3.33331C1.9526 17.5 0.833313 16.3807 0.833313 15V5ZM3.33331 4.16667C2.87308 4.16667 2.49998 4.53976 2.49998 5V6.19484L9.57123 10.4376C9.83513 10.5959 10.1648 10.5959 10.4287 10.4376L17.5 6.19484V5C17.5 4.53976 17.1269 4.16667 16.6666 4.16667H3.33331ZM17.5 8.13849L11.2862 11.8667C10.4945 12.3418 9.50545 12.3418 8.71374 11.8667L2.49998 8.13849V15C2.49998 15.4602 2.87308 15.8333 3.33331 15.8333H16.6666C17.1269 15.8333 17.5 15.4602 17.5 15V8.13849Z" />
                    </svg>
                </button>
            </span>
            <input type="text" style="width: 100%;" class="text-sm z-0 h-16 pl-14 bg-white shadow-xs placeholder-secondary rounded-3xl focus:caret-agrume focus:border-agrume focus:ring-1 focus:ring-agrume focus:outline-none focus:placeholder-white" placeholder="Email" autocomplete="off" >
        </section>
        <section class="mt-5 form-input-text relative h-16 text-secondary">
            <span class="absolute inset-y-0 left-0 h-16 z-10 flex items-center pl-6">
                <button type="submit" class="p-1 focus:outline-none focus:shadow-outline">
                    <svg viewBox="0 0 20 20" class="w-5 h-5 fill-secondary">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 15.833C11.3807 15.833 12.5 14.7137 12.5 13.333C12.5 11.9523 11.3807 10.833 10 10.833C8.61929 10.833 7.5 11.9523 7.5 13.333C7.5 14.7137 8.61929 15.833 10 15.833ZM10 14.1663C10.4602 14.1663 10.8333 13.7932 10.8333 13.333C10.8333 12.8728 10.4602 12.4997 10 12.4997C9.53976 12.4997 9.16667 12.8728 9.16667 13.333C9.16667 13.7932 9.53976 14.1663 10 14.1663Z"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 7.49967V5.83301C5 3.07158 7.23858 0.833008 10 0.833008C12.7614 0.833008 15 3.07158 15 5.83301V7.49967C16.3807 7.49967 17.5 8.61896 17.5 9.99967V16.6663C17.5 18.0471 16.3807 19.1663 15 19.1663H5C3.61929 19.1663 2.5 18.0471 2.5 16.6663V9.99967C2.5 8.61896 3.61929 7.49967 5 7.49967ZM6.66667 5.83301C6.66667 3.99206 8.15905 2.49967 10 2.49967C11.8409 2.49967 13.3333 3.99206 13.3333 5.83301V7.49967H6.66667V5.83301ZM5 9.16634C4.53976 9.16634 4.16667 9.53944 4.16667 9.99967V16.6663C4.16667 17.1266 4.53976 17.4997 5 17.4997H15C15.4602 17.4997 15.8333 17.1266 15.8333 16.6663V9.99967C15.8333 9.53944 15.4602 9.16634 15 9.16634H5Z"/>
                    </svg>
                </button>
            </span>
            <input type="password" style="width: 100%;" class="text-sm z-0 h-16 pl-14 bg-white shadow-xs placeholder-secondary rounded-3xl focus:caret-agrume focus:border-agrume focus:ring-1 focus:ring-agrume focus:outline-none focus:placeholder-white" placeholder="Password" autocomplete="off" >
        </section>
    </section>
    <span class="text-agrume text-xs text-right italic">Forgot password?</span>
    <div class="bg-secondary h-16 rounded-3xl text-center text-primary flex items-center justify-center">Sign In</div>
    <div class="bg-primary  h-16 text-center -secondary rounded-3xl flex items-center justify-center"><span>Sign Up</span></div>
    <section id="social" class="">
        <div class=" text-xs text-center">Or sign in/up with</div>
        <section id="social-providers" class=" mt-5 flex flex-row justify-between">
            <div id="google-provider" class="bg-white w-14 h-14 rounded-full">
                <img src="/img/icon/google-xs.png" class="m-auto mt-4" on:click={sso.google} alt="Google">
            </div>
            <div id="fb-provider" class="bg-white w-14 h-14 rounded-full">
                <img src="/img/icon/fb-xs.png"  class="m-auto mt-4" on:click={sso.fb} alt="Fb">
            </div>
            <div id="apple-provider" class="bg-white w-14 h-14 rounded-full">
                <img src="/img/icon/apple-xs.png" class="m-auto mt-4" on:click={sso.twitter} alt="Twitter">
            </div>
        </section>
    </section>
    -->
    
</section>
<!--section in:scale="{{delay: 250, duration: 300, easing: quintOut }}" out:scale="{{delay: 250, duration: 300, easing: quintOut }}" class="p-6"> 
    <h1>Login</h1>
    {#if $user.isLoggedIn}
        <div class="shrink-0">
            <img src="{$user.photoURL}" class="rounded-full w-8" alt="Avatar" referrerpolicy="no-referrer">
        </div>
        <div class="grow ml-3">
            <p class="text-sm font-semibold text-blue-600">{$user.displayName}</p>
            <p on:click={logout}>logout</p>
        </div>
    {:else}
        <img class="h-8" on:click={loginWithGoogle} src="/img/btn/google_signin_dark_normal_web.png" alt="Login with Google"/>	
    {/if}	
    <ul>
        <li on:click={() => $page = '/home'}>Home</li>
        <li on:click={() => $page = '/plan'}>Plan</li>
    </ul>

</section-->

<style lang="postcss">
    
    .bg-bubbles{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        
        z-index: 10;
    }    
    li{
        position: absolute;
        list-style: none;
        display: block;
        width: 5px;
        height: 5px;
        background-color: white;
        opacity: .2;
        bottom: -10px;
        
        -webkit-animation: square 25s infinite;
        animation:         square 25s infinite;
        
        -webkit-transition-timing-function: linear;
        transition-timing-function: linear;
    }

    li:nth-child(1){
        left: 10%;
    }
    
    li:nth-child(2){
        left: 20%;
        
        width: 7px;
        height: 7px;
        
        animation-delay: 2s;
        animation-duration: 17s;
    }
    
    li:nth-child(3){
        left: 25%;
        animation-delay: 4s;
    }
    
    li:nth-child(4){
        left: 40%;
        width: 5px;
        height: 5px;
        
        animation-duration: 22s;
        
        background-color: white;
        opacity: .25;
    }
    
    li:nth-child(5){
        left: 70%;
    }
    
    li:nth-child(6){
        left: 80%;
        width: 8px;
        height: 8px;
        
        animation-delay: 3s;
        background-color: white;
        opacity: 20%;
    }
    
    li:nth-child(7){
        left: 32%;
        width: 9px;
        height: 9px;
        
        animation-delay: 7s;
    }
    
    li:nth-child(8){
        left: 55%;
        width: 2px;
        height: 2px;
        
        animation-delay: 15s;
        animation-duration: 40s;
    }
    
    li:nth-child(9){
        left: 25%;
        width: 2px;
        height: 2px;
        
        animation-delay: 2s;
        animation-duration: 40s;
        background-color:white;
        opacity: 30%;
    }
    
    li:nth-child(10){
        left: 90%;
        width: 6px;
        height: 6px;
        
        animation-delay: 11s;
    }

    @-webkit-keyframes square {
        0%   { transform: translateY(0); }
        100% { transform: translateY(-900px) rotate(600deg); }
    }
    @keyframes square {
        0%   { transform: translateY(0); }
        100% { transform: translateY(-900px) rotate(600deg); }
    }

</style>